import { IItem } from '../interfaces/organizations';

export const createOrgMap = (orgList: IItem[]): Record<string, IItem> => {
  return orgList?.reduce(
    (acc, org) => ({
      ...acc,
      [org.id]: org,
    }),
    {},
  );
};
